import React from 'react';
import { Link } from '@reach/router';
import PropTypes from 'prop-types';

// import data
import { phBranchesData } from './data';

// import components
import State from '../State';

// import styled components
import { Grid } from '../styled';
import { BranchTile, BranchTileContainer } from './styled';

const BranchTiles = ({ branches, loading }) => {
  const drawBranchTiles = branches => {
    return branches.map(branch => {
      const { city, state, mod, path } = branch;
      return (
        <BranchTile key={path} className={state.toLowerCase()}>
          <Link to={path}>
            <h2>{`${city}, ${state} ${mod}`}</h2>
            <State className={state.toLowerCase()} state={state.toLowerCase()} />
          </Link>
        </BranchTile>
      );
    });
  };

  const drawPlaceholderBranchTiles = branches => {
    return branches.map((branch, i) => {
      const { city, state, mod = '' } = branch;
      return (
        <BranchTile key={`${city}-${state}-${i}`}>
          <Link className="fuzzy" to="/">
            <h2>{`${city}, ${state} ${mod}`}</h2>
            <State className={state.toLowerCase()} state={state.toLowerCase()} />
          </Link>
        </BranchTile>
      );
    });
  };

  if (loading) {
    return (
      <Grid>
        <BranchTileContainer>{drawPlaceholderBranchTiles(phBranchesData)}</BranchTileContainer>
      </Grid>
    );
  }

  return (
    <Grid>
      <BranchTileContainer>{drawBranchTiles(branches)}</BranchTileContainer>
    </Grid>
  );
};

export default BranchTiles;

BranchTiles.propTypes = {
  branches: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

BranchTiles.defaultProps = {
  branches: [],
};
